import { useFormContext, Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import {
  QUESTION_EXPLANATION_MIN_LENGTH,
  QUESTION_EXPLANATION_MAX_LENGTH,
} from 'cat-shared/utils'

import { AppFormTextArea } from 'client/ui-building-blocks'

type Props = {
  isLoading: boolean
}

const ExplanationTextArea = ({ isLoading }: Props) => {
  const { t } = useTranslation()

  const {
    control,
    formState: { errors },
  } = useFormContext()

  return (
    <Controller
      control={control}
      name="explanation"
      rules={{
        required: t('common.validation.required'),
        minLength: {
          value: QUESTION_EXPLANATION_MIN_LENGTH,
          message: t('common.validation.minLength', {
            min: QUESTION_EXPLANATION_MIN_LENGTH,
          }),
        },
        maxLength: {
          value: QUESTION_EXPLANATION_MAX_LENGTH,
          message: t('common.validation.maxLength', {
            max: QUESTION_EXPLANATION_MAX_LENGTH,
          }),
        },
      }}
      render={({ field: { value, onChange } }) => {
        return (
          <AppFormTextArea
            value={value}
            onChange={onChange}
            label={t('createQuestionPage.fields.explanation.label')}
            placeholder={t('createQuestionPage.fields.explanation.placeholder')}
            disabled={isLoading}
            maxLength={QUESTION_EXPLANATION_MAX_LENGTH}
            error={String(errors.explanation?.message || '')}
          />
        )
      }}
    />
  )
}

export default ExplanationTextArea
